import React from "react";

interface BillingCardProps {
  plan: string;
  price: string;
  billingCycle: string;
  nextBillingDate: string;
  billingEmail: string;
}

const CompanyBillingCard: React.FC<BillingCardProps> = ({
  plan,
  price,
  billingCycle,
  nextBillingDate,
  billingEmail,
}) => {
  return (
    <div className="w-full">
      <div className="rounded-lg bg-gradient-to-r from-[#143887] to-[#00032A] text-white p-5 flex justify-between items-start">
        <div>
          <p className="text-xs text-[#FFCD03] font-semibold mb-5">{plan}</p>
          <p className="text-2xl font-extrabold">{price}</p>
        </div>
        <p className="text-xs mt-auto text-gray-200">Price/month</p>
      </div>

      <div className="grid grid-cols-2 mt-5 gap-y-4 text-sm">
        <p className="text-[#00032A] font-bold text-sm">Next billing date</p>
        <p className="text-[#4F4F4F]">{nextBillingDate}</p>

        <p className="text-[#00032A] font-bold text-sm">Billing period</p>
        <p className="text-[#4F4F4F]">{billingCycle}</p>

        <p className="text-[#00032A] font-bold text-sm">Billing email</p>
        <p className="text-[#4F4F4F] break-words">{billingEmail}</p>
      </div>
    </div>
  );
};

export default CompanyBillingCard;
